<ng-container *ngIf="policy?.isDelinquency; else isNotDelinquency">
    <div class="deliquency bn-error-notice-sec">
        <app-bn-error-notice
            [amount]='policy?.exitDelinquencyAmount?.theAmount'
            [date]='policy?.policyCancellationEffectiveDate'
            [policyCancellationReason]='policy?.policyCancellationReason' 
            [policy]='policy' [source]="'bn-overview'">
        </app-bn-error-notice>
    </div>
</ng-container>
<ng-template #isNotDelinquency>
    <ng-container *ngIf="policy?.hasAffinityGroup; else cancelledImpNotice">
        <div class="bn-alert-notice bn-affinity" *ngIf="!hideAffinityAlert">
            <div class="bn-icon">
                <img src="./assets/img/images/icon-info-32.svg" alt="success icon" />
            </div>
            <div class="bn-content">
                <div class="bn-content-text">
                    <div class="bn-content-text-sub">
                        <div class="bn-content-text-title">The billing on this policy is being handled by your agent
                        </div>
                        <div class="bn-content-close">
                            <img src="./assets/img/images/icon-close-18.svg" class="cursor-pointer" alt="close icon"
                                (click)="onAffinityClose()" />
                        </div>
                    </div>
                    <hr class="bn-hr-margin bn-hr-border">
                    <div class="bn-contact-agent bn-agent-text">
                        <ng-container *ngIf="isAcmic; else maAssistance">
                            <div class="font-weight-500 mb-1">
                                    Contact us for assistance
                            </div>
                            <div class="bn-contact-agent-info">
                                <div class="bn-agent-phone mt-0">
                                    <div>
                                        {{ 'PHONE' | translate }}
                                    </div>
                                    <div class="ml-1">
                                        <a href="tel:1-844-295-4500" class="mapfre link red-text">
                                            {{ '1-844-295-4500' }}</a>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #maAssistance>
                            <div class="font-weight-500 mb-2">
                                    Contact your agent for assistance
                            </div>
                            <div class="bn-contact-agent-info">
                                <div>{{ agentName }}</div>
                                <div class="bn-agent-phone" *ngIf="agentPhoneNumber">
                                    <div>
                                        {{ 'PHONE' | translate }}
                                    </div>
                                    <div class="ml-1">
                                        <a href="tel:{{agentPhoneNumber}}" class="mapfre link red-text">
                                            {{ agentPhoneNumber | formatPhone }}</a>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                        <!-- <div class="font-weight-500 mb-2">
                        <ng-container *ngIf="isAcmic; else maAssistance">
                            Contact us for assistance
                        </ng-container>
                        <ng-template #maAssistance>
                            Contact your agent for assistance
                        </ng-template></div>
                        <div class="bn-contact-agent-info">
                            <div>{{ policy?.agent?.agentName }}</div>
                            <div class="bn-agent-phone" *ngIf="agentPhoneNumber">
                                <div>
                                    {{ 'PHONE' | translate }}
                                </div>
                                <div class="ml-1">
                                    <a href="tel:{{agentPhoneNumber}}" class="mapfre link red-text">
                                        {{ agentPhoneNumber | formatPhone }}</a>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-template #cancelledImpNotice>
        <ng-container *ngIf="policy?.policyStatus === 'CANCELLED'; else paidInFull">
            <app-bn-imp-notice 
                [policy]="policy"
            ></app-bn-imp-notice>

        </ng-container>
        <ng-template #paidInFull>
        <ng-container *ngIf="policy?.billingDetails[0]?.outstandingbalance === 0">
            <div class="bn-alert-notice" *ngIf="!hideAlert">
                <div class="bn-icon">
                    <img src="./assets/img/images/icon-check-success.svg" alt="success icon" />
                </div>
                <div class="bn-content">
                    <div class="bn-content-text">
                        <div class="bn-content-text-sub">
                            <div class="bn-content-text-title">You’re all set</div>
                            <div class="bn-content-close">
                                <img src="./assets/img/images/icon-close-18.svg" class="cursor-pointer" alt="close icon"
                                    (click)="onClose()" />
                            </div>
                        </div>
                        <div class="line-height lh-18">Your policy is paid in full, no payment is due at this time.</div>
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-template>
    </ng-template>
</ng-template>